import { LanguageCodeType } from 'noddi-util';
import { createContext, Dispatch, SetStateAction } from 'react';

interface LanguageContextType {
  currentLanguage: LanguageCodeType;
  setCurrentLanguage: Dispatch<SetStateAction<LanguageCodeType>>;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
